export default "assets/images/icons/tiktok-5fe6bfa7.svg";